/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

import { mobile } from '../../../../../utils/mixins'

import CloudinaryS3LazyLoadedImage from '../../../../CloudinaryS3LazyLoadedImage'

export const FullWidthImageContainer = styled('div')`
  display: flex;
  margin-bottom: ${props => (props.includeBottomMargin ? '0.9375em' : 0)};
  ${mobile} {
    margin-bottom: 12px;
  }
`

export const TestimonialImage = styled(CloudinaryS3LazyLoadedImage)`
  width: 100%;
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/ImageTestimonial/styledComponents.js